import { useEffect, useState } from 'react';

import { usePaymentConfig } from 'providers/cache/cachedDataHooks';
import { clearFraudSessionId, storeFraudSessionId } from 'utils/localStorageData';

export const useFraudSession = () => {
  const { paymentConfig } = usePaymentConfig();
  const [isLoaded, setIsLoaded] = useState(deriveIsLoaded);

  useEffect(() => {
    if (!isLoaded) {
      const finixScript = document.getElementById('finix-script');

      if (finixScript) {
        const handleFinixLoaded = () => setIsLoaded(true);

        finixScript.addEventListener('load', handleFinixLoaded);
        return () => finixScript.removeEventListener('load', handleFinixLoaded);
      }

      setIsLoaded(deriveIsLoaded());
    }
  }, [isLoaded]);

  useEffect(() => {
    if (!paymentConfig) {
      return;
    }

    const { finixEnvironment, finixMerchantId } = paymentConfig;
    if (!finixMerchantId || !finixEnvironment) {
      return;
    }

    if (isLoaded) {
      window.Finix.Auth(finixEnvironment, finixMerchantId, (sessionKey: string) => {
        storeFraudSessionId(sessionKey);
      });
    }

    return () => clearFraudSessionId();
  }, [paymentConfig, isLoaded]);
};

const deriveIsLoaded = () => !!window.Finix?.Auth;
